import {
  TRAIL_DETAILS_LATERALMOVEMENT_REQ,
  TRAIL_DETAILS_LATERALMOVEMENT_REQ_SUCCESS,
  TRAIL_DETAILS_LATERALMOVEMENT_REQ_ERROR
} from './trailsinfo.type'

import ApiRest from '@/api/api-rest'
import Trail from '@/resources/models/Trail'

const state = {
  trailDetailMovementsStatus: '',
  trailDetailsLateralMovement: {}
}

const getters = {
  trailDetailMovementsStatus: state => state.trailDetailMovementsStatus,
  trailDetailsLateralMovement: state => state.trailDetailsLateralMovement
}

// Best Practice - updates state
const mutations = {
  [TRAIL_DETAILS_LATERALMOVEMENT_REQ]: state => {
    state.trailDetailMovementsStatus = 'inprogress'
  },
  [TRAIL_DETAILS_LATERALMOVEMENT_REQ_SUCCESS]: (state, details) => {
    state.trailDetailMovementsStatus = 'saved'
  },
  [TRAIL_DETAILS_LATERALMOVEMENT_REQ_ERROR]: state => {
    state.trailDetailMovementsStatus = 'failed'
  }
}

// Best Practice - actions call mutations
// make api call and commit states
const actions = {
  [TRAIL_DETAILS_LATERALMOVEMENT_REQ] (context, trailId) {
    let trailIdEncoded = encodeURIComponent(trailId)
    return new Promise((resolve, reject) => {
      context.commit(TRAIL_DETAILS_LATERALMOVEMENT_REQ)
      ApiRest()
        .get(`/trails/lateralmovement/${trailIdEncoded}`)
        .then(({ data }) => {
          // on polling refresh call, update trail
          resolve(data)
        })
        .catch(errMsg => {
          context.commit(TRAIL_DETAILS_LATERALMOVEMENT_REQ_ERROR, errMsg)
          reject(errMsg)
        })
    })
  },
  [TRAIL_DETAILS_LATERALMOVEMENT_REQ_SUCCESS] (context) {
    context.commit(TRAIL_DETAILS_LATERALMOVEMENT_REQ_SUCCESS)
  },
  [TRAIL_DETAILS_LATERALMOVEMENT_REQ_ERROR] (context) {
    context.commit(TRAIL_DETAILS_LATERALMOVEMENT_REQ_ERROR)
  }
}

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/trails/trailmovement.module.js